import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { CartDrawer } from "./components/CartDrawer";
import { AdminPage } from "./pages/AdminPage";
import { CheckoutSuccessPage } from "./pages/CheckoutSuccessPage";
import { EventsPage } from "./pages/EventsPage";
import { HomePage } from "./pages/HomePage";
import { InfoPage } from "./pages/InfoPage";
import { MenuPage } from "./pages/MenuPage";
import { PrivateChefPage } from "./pages/PrivateChefPage";
import { RecipesPage } from "./pages/RecipesPage";
import { ShopPage } from "./pages/ShopPage";
import { CartProvider } from "./lib/cart";
import { useEffect, useState } from "react";

function currentPath() {
  return window.location.pathname;
}

export function App() {
  const [path, setPath] = useState(currentPath());

  useEffect(() => {
    const sync = () => setPath(currentPath());
    window.addEventListener("popstate", sync);
    return () => window.removeEventListener("popstate", sync);
  }, []);

  return (
    <CartProvider>
      {path.startsWith("/admin") ? (
        <AdminPage />
      ) : (
        <>
          <Header />
          {route(path)}
          <Footer />
          <CartDrawer />
        </>
      )}
    </CartProvider>
  );
}

function route(path: string) {
  if (path === "/" || path === "") return <HomePage />;
  if (path.startsWith("/menus")) return <MenuPage />;
  if (path.startsWith("/private-chef")) return <PrivateChefPage />;
  if (path.startsWith("/recipes")) return <RecipesPage />;
  if (path.startsWith("/events")) return <EventsPage />;
  if (path.startsWith("/shop")) return <ShopPage />;
  if (path.startsWith("/checkout/success")) return <CheckoutSuccessPage />;
  if (path.startsWith("/our-story")) return <InfoPage page="our-story" />;
  if (path.startsWith("/press")) return <InfoPage page="press" />;
  if (path.startsWith("/contact")) return <InfoPage page="contact" />;
  if (path.startsWith("/privacy")) return <InfoPage page="privacy" />;
  if (path.startsWith("/terms")) return <InfoPage page="terms" />;
  return <InfoPage page="not-found" />;
}
